import { createSelector } from '@reduxjs/toolkit'

export const routes = state => state.routes

export const routesSelector = createSelector(routes, routes => ({
	routes,
}))
